"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextMenuLink = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyDrawLayout_1 = require("../draw/SankeyDrawLayout");
const SankeyMenuConfigurationLinksAppearence_1 = require("../configmenus/SankeyMenuConfigurationLinksAppearence");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const SankeyUtils_1 = require("../configmenus/SankeyUtils");
const d3 = __importStar(require("d3"));
const SankeyDrawFunction_1 = require("../draw/SankeyDrawFunction");
const icon_open_modal = react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { style: { float: 'right' }, icon: free_solid_svg_icons_1.faUpRightFromSquare });
const sep = react_1.default.createElement(react_bootstrap_1.Button, { variant: 'light', disabled: true },
    react_1.default.createElement("hr", { style: { borderStyle: 'none', margin: '0px', color: 'grey', backgroundColor: 'grey', height: 2 } }));
const checked = (b) => react_1.default.createElement("span", { style: { float: 'right' } }, b ? '✓' : '');
const ContextMenuLink = ({ applicationContext, dict_variable_application_data, dict_variable_elements_selected, contextMenu, dict_hook_ref_setter_show_dialog_components, node_function, link_function, ComponentUpdater }) => {
    const [contextualised_link, set_contextualised_link] = (0, react_1.useState)();
    contextMenu.ref_setter_contextualised_link.current = set_contextualised_link;
    const [forceUpdate, setForceUpdate] = (0, react_1.useState)(false);
    const { pointer_pos } = contextMenu;
    const { multi_selected_links, displayedInputLinkValueSetterRef, displayedInputLinkValueRef } = dict_variable_elements_selected;
    const { data } = dict_variable_application_data;
    const { t } = applicationContext;
    const { RedrawNodes } = node_function;
    const { RedrawLinks } = link_function;
    const redraw_selected_links = () => {
        d3.selectAll('.gg_links').filter((g_l) => {
            const cast_l = g_l;
            return multi_selected_links.current.includes(cast_l);
        }).remove();
        link_function.CreateLinksOnSVG(multi_selected_links.current);
        ComponentUpdater.updateComponentMenuConfigLink.current();
        setForceUpdate(!forceUpdate);
    };
    const newEntries = new Map(Object.entries(data.dataTags).map(([dataTagKey, dataTag]) => {
        return (Object.keys(dataTag.tags).length > 0) ? [
            dataTagKey,
            Object.entries(dataTag.tags).filter(tag => tag[1].selected).length > 0 ? Object.entries(dataTag.tags).filter(tag => tag[1].selected)[0][0] : Object.keys(dataTag.tags)[0]
        ] : ['n', 'n'];
    }));
    const tags_selected = Object.fromEntries(newEntries);
    let style_c_l = '0px 0px auto auto';
    if (contextualised_link) {
        style_c_l = (pointer_pos.current[1] - 20) + 'px auto auto ' + (pointer_pos.current[0] + 10) + 'px';
    }
    const invert_flux = (l, nodes_to_reorganize) => {
        const tmp = l.idSource;
        const previous_node_s = data.nodes[l.idSource];
        previous_node_s.outputLinksId.splice(previous_node_s.outputLinksId.indexOf(l.idLink), 1);
        const source_node = data.nodes[l.idTarget];
        l.idSource = source_node.idNode;
        source_node.outputLinksId.push(l.idLink);
        nodes_to_reorganize.push(source_node);
        const previous_node_t = data.nodes[l.idTarget];
        previous_node_t.inputLinksId.splice(previous_node_t.inputLinksId.indexOf(l.idLink), 1);
        const target_node = data.nodes[tmp];
        l.idTarget = target_node.idNode;
        target_node.inputLinksId.push(l.idLink);
        nodes_to_reorganize.push(target_node);
    };
    const remake_display_links = () => {
        const pre_link_key = Object.keys(dict_variable_application_data.display_links);
        const new_display_links = {};
        data.linkZIndex.filter(lk => pre_link_key.includes(lk)).forEach(lk => new_display_links[lk] = dict_variable_application_data.display_links[lk]);
        dict_variable_application_data.display_links = new_display_links;
        redraw_selected_links();
    };
    const value_selected_parameter_contextualised_link = () => {
        if (contextualised_link === undefined) {
            return {};
        }
        else {
            if (Object.keys(data.links).length === 0 || !(contextualised_link.idLink in data.links)) {
                let val = JSON.parse(JSON.stringify(Object(contextualised_link.value)));
                Object.values(tags_selected).map(tag_selected => {
                    if (val[tag_selected] === undefined) {
                        val[tag_selected] = {};
                    }
                    val = val[tag_selected];
                });
                return val;
            }
            let val = JSON.parse(JSON.stringify(Object(data.links[contextualised_link.idLink].value)));
            Object.values(tags_selected).map(tag_selected => {
                if (val[tag_selected] === undefined) {
                    val[tag_selected] = { 'display_value': '', tags: {}, value: 0 };
                }
                val = val[tag_selected];
            });
            return val;
        }
    };
    const context_link_label_visible = contextualised_link !== undefined ? (0, SankeyUtils_1.ReturnValueLink)(data, contextualised_link, 'label_visible') : false;
    const has_flux_tags = Object.values(data.fluxTags).length > 0;
    // Dropdown to change some pararmeter concerning the appearence of the node
    const dropdown_c_l_tag = (contextualised_link !== undefined && has_flux_tags) && has_flux_tags ? react_1.default.createElement(react_bootstrap_1.Dropdown, { as: react_bootstrap_1.ButtonGroup, variant: 'light', autoClose: 'outside', drop: 'end' },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('Menu.Transformation.tagFlux_assign')),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' }, Object.entries(data.fluxTags).filter(nt => Object.keys(nt[1].tags).length > 0).map(nt => {
            return react_1.default.createElement(react_bootstrap_1.Dropdown, { as: react_bootstrap_1.Button, variant: 'light', autoClose: 'outside', drop: 'end' },
                react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, nt[1].group_name),
                react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' }, Object.keys(nt[1].tags).map(t => {
                    const has_tag = value_selected_parameter_contextualised_link().tags[nt[0]] !== undefined;
                    const is_selected = value_selected_parameter_contextualised_link().tags[nt[0]] && value_selected_parameter_contextualised_link().tags[nt[0]].includes(t);
                    return react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                            // Assign tag to selected links
                            multi_selected_links.current.filter(l => l !== contextualised_link).forEach(l => {
                                (0, SankeyUtils_1.updateLinkTagValue)(l, tags_selected, nt[0], t, !is_selected);
                            });
                            (0, SankeyUtils_1.updateLinkTagValue)(contextualised_link, tags_selected, nt[0], t, !is_selected);
                            redraw_selected_links();
                        } },
                        nt[1].tags[t].name,
                        has_tag ? checked(value_selected_parameter_contextualised_link().tags[nt[0]].includes(t)) : react_1.default.createElement(react_1.default.Fragment, null));
                })));
        }))) : react_1.default.createElement(react_1.default.Fragment, null);
    const button_open_link_appearence = contextualised_link !== undefined ? react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => {
            dict_hook_ref_setter_show_dialog_components.ref_setter_show_menu_link_appearence.current(true);
            set_contextualised_link(undefined);
        }, variant: 'light' },
        t('Flux.apparence.apparence'),
        " ",
        icon_open_modal) : react_1.default.createElement(react_1.default.Fragment, null);
    // Dropdown to change some pararmeter concerning the style of the node
    const dropdown_c_l_style_select = contextualised_link !== undefined ? react_1.default.createElement(react_bootstrap_1.Dropdown, { autoClose: 'outside', as: react_bootstrap_1.ButtonGroup, variant: 'light', drop: 'end' },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('Noeud.SelectStyle')),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' }, Object.values(data.style_link).map(sn => {
            return react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                    contextualised_link.style = sn.idLink;
                    multi_selected_links.current.filter(n => n != contextualised_link).forEach(n => n.style = sn.idLink);
                    redraw_selected_links();
                } },
                sn.name,
                checked(contextualised_link.style == sn.idLink));
        }))) : react_1.default.createElement(react_1.default.Fragment, null);
    const dropdown_c_l_style = contextualised_link !== undefined ? react_1.default.createElement(react_bootstrap_1.Dropdown, { autoClose: 'outside', as: react_bootstrap_1.ButtonGroup, variant: 'light', drop: 'end' },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('Noeud.editStyle')),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' },
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { as: react_bootstrap_1.Button, variant: 'light', onClick: () => {
                    delete contextualised_link.local;
                    multi_selected_links.current.filter(n => n != contextualised_link).forEach(n => delete n.local);
                } }, t('Noeud.AS')),
            dropdown_c_l_style_select)) : react_1.default.createElement(react_1.default.Fragment, null);
    const dropdown_c_l_layout = contextualised_link !== undefined ? react_1.default.createElement(react_bootstrap_1.Dropdown, { autoClose: 'outside', as: react_bootstrap_1.ButtonGroup, variant: 'light', drop: 'end' },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('Flux.layout')),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' },
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                    multi_selected_links.current.map(l => {
                        const i = l.idLink;
                        const { links } = data;
                        const listElmt = Object.keys(links);
                        const posElemt = listElmt.indexOf(i);
                        listElmt.splice(posElemt, 1);
                        listElmt.splice(listElmt.length, 0, i);
                        const new_cat = {};
                        listElmt.forEach(elt => {
                            new_cat[elt] = links[elt];
                        });
                        for (const member in links)
                            delete links[member];
                        Object.assign(links, new_cat);
                    });
                    remake_display_links();
                } }, t('Flux.layoutTop')),
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                    multi_selected_links.current.forEach(n => (0, SankeyMenuConfigurationLinksAppearence_1.handleDownLink)(data, n.idLink));
                    remake_display_links();
                } }, t('Flux.layoutUp')),
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                    multi_selected_links.current.forEach(n => (0, SankeyMenuConfigurationLinksAppearence_1.handleUpLink)(data, n.idLink));
                    remake_display_links();
                } }, t('Flux.layoutDown')),
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                    multi_selected_links.current.map(l => {
                        const i = l.idLink;
                        const { links } = data;
                        const listElmt = Object.keys(links);
                        const posElemt = listElmt.indexOf(i);
                        listElmt.splice(posElemt, 1);
                        listElmt.splice(0, 0, i);
                        const new_cat = {};
                        listElmt.forEach(elt => {
                            new_cat[elt] = links[elt];
                        });
                        for (const member in links)
                            delete links[member];
                        Object.assign(links, new_cat);
                    });
                    remake_display_links();
                } }, t('Flux.layoutBottom')))) : react_1.default.createElement(react_1.default.Fragment, null);
    const button_open_link_data = contextualised_link !== undefined ? react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => {
            dict_hook_ref_setter_show_dialog_components.ref_setter_show_menu_link_data.current(true);
            set_contextualised_link(undefined);
        }, variant: 'light' },
        t('Flux.data.données'),
        " ",
        icon_open_modal) : react_1.default.createElement(react_1.default.Fragment, null);
    const button_mask_link_label = contextualised_link !== undefined ? react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => {
            multi_selected_links.current.forEach(l => {
                (0, SankeyUtils_1.AssignLinkLocalAttribute)(l, 'label_visible', !context_link_label_visible);
            });
        }, variant: 'light' }, context_link_label_visible ? t('Flux.apparence.hide_link_lab') : t('Flux.apparence.display_link_lab')) : react_1.default.createElement(react_1.default.Fragment, null);
    const button_open_link_tooltip = contextualised_link !== undefined ? react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => {
            dict_hook_ref_setter_show_dialog_components.ref_setter_show_menu_link_tooltip.current(true);
            set_contextualised_link(undefined);
        }, variant: 'light' },
        t('Flux.IS'),
        " ",
        icon_open_modal) : react_1.default.createElement(react_1.default.Fragment, null);
    const btn_l_show_tags_menu = react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => {
            dict_hook_ref_setter_show_dialog_components.ref_setter_show_menu_link_tags.current(true);
            set_contextualised_link(undefined);
            contextMenu.ref_contextualised_node.current = undefined;
        }, variant: 'light' },
        t('Menu.Etiquettes'),
        " ",
        icon_open_modal);
    const btn_edit_value = contextualised_link !== undefined ? react_1.default.createElement(react_bootstrap_1.Dropdown, { autoClose: 'outside', as: react_bootstrap_1.ButtonGroup, variant: 'light', drop: 'end' },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('Flux.data.edit_value')),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, null,
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, null,
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'string', value: displayedInputLinkValueRef.current, onChange: evt => {
                        displayedInputLinkValueSetterRef.current.forEach(setter => setter(evt.target.value));
                        const formatedValue = evt.target.value.replace(',', '.');
                        if (formatedValue != '' && isNaN(+formatedValue)) {
                            d3.select('.inputValueLink').style('border', 'red 1px solid');
                        }
                        else {
                            d3.select('.inputValueLink').style('border', '#ced4da 1px solid');
                        }
                    }, onBlur: evt => {
                        const formatedValue = evt.target.value.replace(',', '.');
                        if (formatedValue !== '' && !isNaN(+formatedValue)) {
                            const was_empty = (0, SankeyDrawFunction_1.ValueSelectedParameter)(dict_variable_application_data, multi_selected_links, tags_selected).value === '';
                            let val = Object(multi_selected_links.current[0].value);
                            const impacted_node = [];
                            multi_selected_links.current.map(d => {
                                const dashed = (0, SankeyUtils_1.ReturnValueLink)(data, multi_selected_links.current[0], 'dashed');
                                (0, SankeyUtils_1.AssignLinkLocalAttribute)(d, 'dashed', (was_empty) ? false : dashed);
                                val = d.value;
                                Object.values(tags_selected).forEach(tag => {
                                    if (val[tag] === undefined) {
                                        val[tag] = {};
                                    }
                                    val = val[tag];
                                });
                                val.value = +formatedValue;
                                impacted_node.push(data.nodes[d.idSource]);
                                impacted_node.push(data.nodes[d.idTarget]);
                            });
                            const scale = d3.scaleLinear()
                                .domain([0, data.user_scale])
                                .range([0, 100]);
                            if (scale(+formatedValue) > 500) {
                                data.user_scale = +formatedValue;
                            }
                            let link_to_update = multi_selected_links.current;
                            impacted_node.forEach(n => {
                                link_to_update = link_to_update.concat(n.outputLinksId.map(lid => data.links[lid]));
                                link_to_update = link_to_update.concat(n.inputLinksId.map(lid => data.links[lid]));
                            });
                            RedrawNodes(impacted_node);
                            RedrawLinks(link_to_update);
                        }
                        else if (formatedValue == '') {
                            const impacted_node = [];
                            let val = Object(multi_selected_links.current[0].value);
                            multi_selected_links.current.map(d => {
                                val = d.value;
                                (0, SankeyUtils_1.AssignLinkLocalAttribute)(d, 'dashed', true);
                                Object.values(tags_selected).forEach(tag => {
                                    if (val[tag] === undefined) {
                                        val[tag] = {};
                                    }
                                    val = val[tag];
                                });
                                val.value = '';
                                impacted_node.push(data.nodes[d.idSource]);
                                impacted_node.push(data.nodes[d.idTarget]);
                            });
                            let link_to_update = multi_selected_links.current;
                            impacted_node.forEach(n => {
                                link_to_update = link_to_update.concat(n.outputLinksId.map(lid => data.links[lid]));
                                link_to_update = link_to_update.concat(n.inputLinksId.map(lid => data.links[lid]));
                            });
                            RedrawNodes(impacted_node);
                            RedrawLinks(link_to_update);
                        }
                    } })))) : react_1.default.createElement(react_1.default.Fragment, null);
    // Pop over that serve as context menu
    return contextualised_link !== undefined ? react_1.default.createElement(react_bootstrap_1.Popover, { id: "context_link_pop_over", style: { maxWidth: '100%', position: 'absolute', inset: style_c_l } },
        react_1.default.createElement(react_bootstrap_1.Popover.Body, null,
            react_1.default.createElement(react_bootstrap_1.ButtonGroup, { vertical: true },
                react_1.default.createElement(react_bootstrap_1.Button, { variant: 'light', onClick: () => {
                        const nodes_to_reorganize = [];
                        invert_flux(contextualised_link, nodes_to_reorganize);
                        multi_selected_links.current.filter(l => l !== contextualised_link).forEach(l => {
                            invert_flux(l, nodes_to_reorganize);
                        });
                        nodes_to_reorganize.forEach(n => {
                            (0, SankeyDrawLayout_1.reorganize_inputLinksId)(data, n, true, true, data.nodes, data.links);
                        });
                        let list_node = [];
                        multi_selected_links.current.forEach(l => {
                            list_node.push(l.idSource);
                            list_node.push(l.idTarget);
                        });
                        list_node = [...new Set(list_node)];
                        // Redraw link attached to modified node when the modification to the node 
                        // modify links path
                        let link_to_update = [];
                        list_node.forEach(nid => {
                            link_to_update = link_to_update.concat(data.nodes[nid].outputLinksId);
                            link_to_update = link_to_update.concat(data.nodes[nid].inputLinksId);
                        });
                        link_to_update = [...new Set(link_to_update)];
                        const list_links = link_to_update.map(lid => data.links[lid]);
                        link_function.RedrawLinks(list_links);
                    } }, t('Flux.if')),
                sep,
                dropdown_c_l_style,
                sep,
                dropdown_c_l_layout,
                button_mask_link_label,
                btn_edit_value,
                has_flux_tags && sep,
                dropdown_c_l_tag,
                sep,
                button_open_link_data,
                button_open_link_appearence,
                btn_l_show_tags_menu,
                button_open_link_tooltip))) : react_1.default.createElement(react_1.default.Fragment, null);
};
exports.ContextMenuLink = ContextMenuLink;
